import { useMemo } from 'react';
import {
  colorRuleLegendEntries,
  type ColorRule,
  type LegendEntry as SharedLegendEntry,
} from '@citizen-walk/shared-types';
import type { DistrictMode } from '@citizen-walk/shared-types';
import { defaultMarkerColorForMode, mapModeLabel } from './mapDefaults';

/**
 * Sprint BG-DataSettings 6+7 (U-H8 / U-H9 / L17) — MapLegend 凡例エントリ生成 hook。
 *
 * 旧 `old/apps/user/src/lib/markerStyle.ts::getQuadrantLegendEntries` 等の凡例生成 logic を踏襲。
 *
 * 仕様:
 *   - colorRule が指定されていれば `colorRuleLegendEntries` (buckets / cells + fallback) を返す
 *   - colorRule が無ければ mode-default ラベル + mode 既定色の 1 件 fallback
 *   - mode も無く colorRule も無いなら空配列 (MapLegend 側で button 非表示にする)
 *
 * 名前について: 旧 v1 で「ECW Legend」と呼ばれていた hook を踏襲したが、現状は ecw / bousai /
 * walker / kids-bousai 全 mode 兼用。
 */
export type MapLegendEntry = SharedLegendEntry;

export function useEcwLegend(
  rule: ColorRule | null | undefined,
  mode: DistrictMode | null | undefined,
): MapLegendEntry[] {
  return useMemo(() => {
    if (rule) {
      return colorRuleLegendEntries(rule);
    }
    const label = mapModeLabel(mode);
    if (!label) return [];
    return [{ color: defaultMarkerColorForMode(mode), label }];
  }, [rule, mode]);
}
